export type HouseBillingCurrency = {
    /**
     * 3-letter currency code
     * @example USD
     * @example JPY
     * @example EUR
     */
    code: string;
    /**
     * Human-readable currency name
     */
    name: string;
};

export type HouseBillingCurrencySlice = {
    availableCurrencies: HouseBillingCurrency[];
    loading: boolean;
    wasSaveSuccessful: boolean | undefined;
};

export const defaultHouseBillingCurrencySlice: HouseBillingCurrencySlice = {
    availableCurrencies: [],
    loading: false,
    wasSaveSuccessful: undefined,
};
